const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function SpeakingCTA() {
  return (
    <section
      data-testid="speaking-final-cta"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "min(72vh, 660px)", background: "#FAFAF8" }}
    >
      <img
        src={`${A}/blueprint4joy-speaking-navy-blazer-stool.jpg`}
        alt="Lara on stage in a navy blazer, seated on a stool addressing her audience."
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "82% 15%", transform: "translateX(18%)" }}
      />

      {/* Cream panel — solid to 40%, completes fade at 57% so face is fully clear */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, #FAFAF8 0%, #FAFAF8 40%, rgba(250,250,248,0.94) 46%, rgba(250,250,248,0.55) 50%, rgba(250,250,248,0.12) 53%, transparent 57%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{
          background:
            "linear-gradient(to right, #FAFAF8 0%, rgba(250,250,248,0.98) 62%, rgba(250,250,248,0.5) 84%, transparent 100%)",
        }}
      />

      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-14 md:pt-20 pb-[43px] min-h-[inherit] flex items-start">
        <div className="max-w-[480px] reveal">
          <p className="font-display text-xl md:text-2xl text-[#5A5A5A] leading-relaxed mb-2">
            If you're looking for someone to simply fill a speaking slot,
          </p>
          <p className="font-display text-xl md:text-2xl text-[#5A5A5A] leading-relaxed mb-12">
            I'm probably not your speaker.
          </p>

          <div className="w-10 h-px bg-[#F6A041] mb-12" />

          <h2 className="font-display text-4xl md:text-5xl lg:text-[60px] leading-[1.05] tracking-tight text-[#1C1917] mb-3">
            If you're looking for a room that leaves clearer than when it arrived...
          </h2>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[60px] leading-[1.05] tracking-tight text-[#F6A041] mb-14">
            Let's talk.
          </h2>

          <a
            href="mailto:lara@blueprint4joy.com"
            data-testid="final-book-cta"
            className={btnPrimary}
          >
            Book Lara to Speak
          </a>
        </div>
      </div>
    </section>
  );
}
